import styled from "@emotion/styled";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box } from "@mui/material";
import { useContext } from "react";
import { primary } from "../../constants/theme";
import { Context } from "../../context/context";
import { sendAnalytics } from "../../utils/analyticsCommon";

const CustomWhatsAppIcon = styled(Box)(({ theme }) => ({
  ".Whatsapp-main": {
    bottom: "70px",
    marginBottom: "16px",
    position: "fixed",
    right: "20px",
    textAlign: "end",
    zIndex: "999",
  },
  ".whatsapp": {
    background: "#35BF68",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    padding: "9px 10px 8px 10px",
    marginLeft: "auto",
    border: "5px solid #ffffff",
  },
  ".whatsapp svg": {
    color: primary.white,
    width: "30px",
    height: "30px",
  },

  "@media (max-width:390px)": {
    fontSize: 12,
  },

  [theme.breakpoints.down("md")]: {},
}));

const WhatsAppFloater = () => {
  const { showConnectDrawer } = useContext(Context);
  return (
    <CustomWhatsAppIcon>
      <Box
        className="Whatsapp-main"
        sx={{
          maxWidth: "100px",
          width: "100%",
          margin: "auto",
          display: { xs: "block", sm: "none" },
        }}
        onClick={() => {
          sendAnalytics(
            "v2_whatsapp_floating_button",
            { type: "floater_whatsapp_icon", trigger: "whatsapp" },
            "en"
          );
          showConnectDrawer("floater_whatsapp_icon");
        }}
      >
        <Box className="whatsapp">
          <WhatsAppIcon className="whatsapp-logo" />
        </Box>
      </Box>
    </CustomWhatsAppIcon>
  );
};

export default WhatsAppFloater;
